import React, { useEffect } from 'react';
import { withWrapper } from '@shared/react';
import {
    AssignPositionTableProvider,
    useClientDetailsTable,
    getTransactionsTableColumns,
    AssignedPositions_TABLE_TITLE,
    UserManagement_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import './AssignPositionTable.scss';
import { BrokerLevelPositionFilters } from './components/BrokerLevelPostionFilters';

interface AssignPositionTableContentProps {
    accountId: number;
}

const AssignPositionTableContent: React.FC<AssignPositionTableContentProps> = ({ accountId }) => {
    const { AssignPositionBody, paginationOptions, setAccountId } = useClientDetailsTable();
    const userStorage = localStorage.getItem('User');
    let userObject = JSON.parse(userStorage ? userStorage : '');

    useEffect(() => {
        if (accountId === 0 || accountId) {
            setAccountId(accountId);
        }
    }, [accountId, setAccountId]);

    return (
        <Table
            columns={getTransactionsTableColumns()}
            data={AssignPositionBody}
            tableTitle={userObject.userRole === 4 ? AssignedPositions_TABLE_TITLE : 'Assigned Securities'}
            infoLink={UserManagement_TABLE_INFO_URL}
            paginationOptions={paginationOptions}
            filters={<BrokerLevelPositionFilters />}
            row={undefined}
            noScroll={true}
        />
    );
};

export const AssignPositionTable = withWrapper(AssignPositionTableProvider)(AssignPositionTableContent);
